import MenuIcon from "@mui/icons-material/Menu";
import { Box, ButtonBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import modelings from "../../../data/c4/modelings.data";
import baseModel from "../data/baseModel.data";
import hqPin from "../data/hqPins.data";
import useBaseModel from "../hooks/useBaseModel";
import useHQModels from "../hooks/useHQModels";
import useModels from "../hooks/useModels";
import usePanoramaClick from "../hooks/usePanoramaClick";
import usePanoramaPins from "../hooks/usePanoramaPins";
import useSelectModels from "../hooks/useSelectModels";
import useSelectedMenuStore from "../stores/useSelectedMenuStore";
import useViewerStore from "../stores/useViewerStore";
import HQToggle from "./HQToggle";
import PanoramaPopup from "./PanoramaPopup";

const titleStyle = {
  width: "100%",
  marginTop: "24px",
  fontFamily: "Arimo",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "30px",
  lineHeight: "22px",
  letterSpacing: "-0.43px",
  color: "#747474",
  cursor: "pointer",
};

const hamburgerIconStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  marginTop: "15px",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  padding: "7px 19px 30px 19px",
  marginLeft: "5px",
  borderRadius: "50%",
};

function KProjectText() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "16px",
        width: "100%",
      }}
    >
      <br />
      <Typography
        key={"k-project"}
        sx={{
          fontFamily: "Arimo",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "22px",
          letterSpacing: "-0.43px",
          color: "#FFFFFF",
          paddingBottom: "30px",
        }}
      >
        K-project
      </Typography>
    </Box>
  );
}

function useBM() {
  const { setBaseModel } = useViewerStore();

  React.useEffect(() => {
    setBaseModel({
      path: baseModel.path,
      adjustHeight: baseModel.adjustHeight,
    });

    return () => {
      setBaseModel();
    };
  }, [setBaseModel]);

  useBaseModel();
}

function useKSS() {
  const { selectedMenu } = useSelectedMenuStore();
  const { setModels } = useViewerStore();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (selectedMenu === "KSS") {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [selectedMenu]);

  React.useEffect(() => {
    if (!isOpen) {
      setModels([]);
    } else {
      // setModels([modelings[1]]);
      const removeHQModels = modelings.filter((model) => model.name !== "HQ");
      setModels(removeHQModels);
      // setModels(modelings);
    }
  }, [isOpen, setModels]);

  useModels();
  useSelectModels();
  usePanoramaPins({ items: hqPin, show: isOpen });
}

export default function Drawer() {
  usePanoramaClick();
  const { setSelectedMenu } = useSelectedMenuStore();
  const [folder, setFolder] = useState(false);
  const [toggleOn, setToggleOn] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // 모바일 화면 크기 기준 (예: 768px 이하)
      if (window.innerWidth <= 768) {
        setFolder(true);
      }
    };

    // 페이지 처음 접속 시 화면 크기 체크
    handleResize();
  }, []);

  // 베이스모델
  useBM();

  // kss 메뉴
  useKSS();

  const { setHQModelShow } = useHQModels();

  useEffect(() => {
    if (toggleOn) {
      setSelectedMenu("KSS");
      setHQModelShow(true);
    } else {
      setSelectedMenu("NOTHING");
      setHQModelShow(false);
    }
  }, [setSelectedMenu, toggleOn, setHQModelShow]);

  return (
    <div style={{ position: "absolute", top: 0, left: 0, zIndex: 100 }}>
      {!folder ? null : (
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <ButtonBase
            sx={hamburgerIconStyle}
            onClick={() => {
              setFolder(false);
            }}
          >
            <MenuIcon sx={{ color: "white" }} />
          </ButtonBase>
        </Box>
      )}
      <Box
        sx={{
          color: "white",
          width: 255,
          height: "100dvh",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          flexDirection: "column",
          alignItems: "center",
          paddingX: "12px",
          minHeight: "500px",
          overflowY: "auto",
          msOverflowStyle: "none", // 스크롤 숨김
          scrollbarWidth: "none", // 스크롤 숨김
          display: folder ? "none" : "flex",
        }}
      >
        {/* ------- 헤더 Start ------- */}
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <ButtonBase
            sx={{
              width: "24px",
              height: "24px",
              display: "flex",
              paddingTop: "22px",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onClick={() => {
              setFolder(true);
            }}
          >
            <MenuIcon sx={{ color: "white" }} />
          </ButtonBase>
          <Typography key={"typo"} sx={titleStyle}>
            &nbsp;Spatial Log
          </Typography>
        </Box>

        {/* ------- K-project Start ------- */}
        <KProjectText />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "16px",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <HQToggle setToggleOn={setToggleOn} toggleOn={toggleOn} />
        </Box>
      </Box>

      {toggleOn && <PanoramaPopup />}
    </div>
  );
}
